import * as firebase from "firebase";
import QuerySnapshot = firebase.firestore.QuerySnapshot;


export function snapToArray(snap: QuerySnapshot): any[] {
  return snap.docs.map((doc) => {
    return doc.data();
  });
}

export function isDefined(v: any):boolean {
  return v !== null && typeof v !== 'undefined';
}


// WEBPACK FOOTER //
// ./src/providers/helper.ts